import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { Col, Row } from "react-bootstrap";

import server from "@/src/api/server";
import Swal from "sweetalert2";
import { useRouter } from "next/router";

const RequestForm = ({ person, onSuccess }) => {
  const { formatMessage, locale } = useIntl();
  const { query } = useRouter();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const getLocalizedValue = (field, locale, fallback = "-") => {
    if (typeof field === "object" && field !== null) {
      const ar = field?.ar?.trim?.();
      const en = field?.en?.trim?.();
      if (!ar && !en) return fallback;
      const localized = field?.[locale]?.trim?.();
      return localized || ar || en || fallback;
    }
    if (typeof field === "string") {
      return field.trim() || fallback;
    }
    return fallback;
  };
  useEffect(() => {
    if (query?.personId)
      reset({
        message: `مهتم بالسيرة الذاتية كود ${query?.personId} والاسم ${query?.name}`,
      });
    else
      reset({
        message: `الاسم: ${person?.name?.ar || ""}
        
الديانة: ${getLocalizedValue(person?.religion, locale) || ""}
    
الكود: ${person?.id || ""}

الدولة: ${getLocalizedValue(person?.country?.name, locale) || ""}
 
العمر: ${person?.age || ""}

اللغة: ${getLocalizedValue(person?.experience, locale) || ""}

سنوات الخبرة: ${person?.name?.experienceYears?.toString().trim() || ""}

رسوم الاستقدام: ${person?.recruitmentFees || ""}
        
        `,
      });
  }, [query?.personId, query?.name, person, reset, locale]);

  const onSubmit = async (data) => {
    try {
      data.personnel = query?.personId;
      await server.post("/requests", data);
      reset();
      onSuccess?.();
      Swal.fire(
        `${formatMessage({
          id: "thanks",
        })}`,
        `${formatMessage({
          id: "thankMsg",
        })}`,
        "success",
      );
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <div className="order-form">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col xs="12" md="6">
              <div className="form-group">
                <label htmlFor="name">
                  {formatMessage({
                    id: "name",
                  })}
                </label>
                <input
                  id="name"
                  className="form-control"
                  {...register("name", {
                    required: true,
                  })}
                />
                {errors?.name?.type === "required" && (
                  <p className="error-hint">
                    <FormattedMessage id="required" />
                  </p>
                )}
              </div>
            </Col>

            <Col xs="12" md="6">
              <div className="form-group">
                <label htmlFor="phone">
                  {formatMessage({
                    id: "phone",
                  })}
                </label>
                <input
                  id="phone"
                  className="form-control"
                  {...register("phone", {
                    required: true,
                  })}
                  {...{
                    maxLength: 14,
                    type: "text",
                    onKeyPress: (event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    },
                  }}
                  // placeholder={formatMessage({
                  //   id: "name",
                  // })}
                />
                {errors?.phone?.type === "required" && (
                  <p className="error-hint">
                    <FormattedMessage id="required" />
                  </p>
                )}
              </div>
              {/* <div className="form-group">
                <label htmlFor="preferredMethod">
                  {formatMessage({
                    id: "preferredMethod",
                  })}
                </label>
                <select
                  id="preferredMethod"
                  className="form-control"
                  {...register("contactMethod", {
                    required: true,
                  })}
                  // placeholder={formatMessage({
                  //   id: "email",
                  // })}
                >
                  <option value="whatsapp">
                    {formatMessage({
                      id: "whatsapp",
                    })}
                  </option>
                  <option value="phone">
                    {formatMessage({
                      id: "phone",
                    })}
                  </option>
                  <option value="email">
                    {formatMessage({
                      id: "email",
                    })}
                  </option>
                </select>
                {errors?.contactMethod?.type === "required" && (
                  <p className="error-hint">
                    <FormattedMessage id="required" />
                  </p>
                )}
              </div> */}
            </Col>

            <Col xs="12" md="12">
              <div className="form-group">
                <label htmlFor="email">
                  {formatMessage({
                    id: "email",
                  })}
                </label>
                <input
                  id="email"
                  type="email"
                  className="form-control"
                  {...register("email", {
                    required: true,
                  })}
                />
                {errors?.email?.type === "required" && (
                  <p className="error-hint">
                    <FormattedMessage id="required" />
                  </p>
                )}
              </div>
            </Col>
            {/* </Row>
          <Row> */}
            {/* {!query?.personId && (
              <Col xs="12"  >
                <div className="form-group">
                  <label htmlFor="country">
                    {formatMessage({
                      id: "country",
                    })}
                  </label>
                  <select
                    id="country"
                    className="form-control"
                    {...register("country", {
                      required: true,
                    })}
                    // placeholder={formatMessage({
                    //   id: "email",
                    // })}
                  >
                    <option>اختر الدولة</option>
                    {countries?.map((country, index) => (
                      <option key={index} value={country?.id}>
                        {country?.name?.[locale]}
                      </option>
                    ))}
                  </select>
                  {errors?.country?.type === "required" && (
                    <p className="error-hint">
                      <FormattedMessage id="required" />
                    </p>
                  )}
                </div>
              </Col>
            )} */}
            {/* </Row>
          <Row> */}
            <Col xs="12">
              <div className="form-group">
                <label htmlFor="details">
                  {formatMessage({
                    id: "details",
                  })}
                </label>
                <textarea
                  id="details"
                  className="form-control"
                  {...register("message", {
                    required: true,
                  })}
                  rows="7"
                  // placeholder={formatMessage({
                  //   id: "details",
                  // })}
                />
                {errors?.message?.type === "required" && (
                  <p className="error-hint">
                    <FormattedMessage id="required" />
                  </p>
                )}
              </div>
            </Col>
            <Col xs="12">
              <div className="form-group button">
                <button type="submit" className="btn gradient-btn">
                  <FormattedMessage id="send" />
                </button>
              </div>
            </Col>
          </Row>
        </form>
      </div>
    </>
  );
};

export default RequestForm;
